import React from 'react';
import { Link } from 'react-router-dom';
import { BadgeCheck, ShieldCheck, ShoppingCart, Truck } from 'lucide-react';

const trustItems = [
  {
    title: 'Inspected & Tested',
    description: 'Quality checked before delivery',
    icon: BadgeCheck,
  },
  {
    title: 'Warranty Coverage',
    description: 'Coverage included with purchase',
    icon: ShieldCheck,
  },
  {
    title: 'Local Pickup & Delivery',
    description: 'Convenient service options',
    icon: Truck,
  },
];

export function HomeHeroSection() {
  return (
    <section className="relative isolate overflow-hidden bg-slate-950">
      <div className="relative min-h-[620px] lg:min-h-[680px]">
        <img
          src="https://images.unsplash.com/photo-1626806787461-102c1bfaaea1?ixlib=rb-4.1.0&auto=format&fit=crop&w=2000&q=85"
          alt="Modern washer and dryer set in a laundry room"
          className="absolute inset-0 h-full w-full object-cover object-[62%_center]"
        />

        <div className="absolute inset-0 bg-slate-950/35" />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-950 via-slate-950/90 to-slate-950/5" />
        <div className="absolute inset-y-0 left-0 w-full bg-[radial-gradient(circle_at_18%_50%,rgba(15,23,42,0.18),transparent_58%)]" />

        <div className="container relative z-10 mx-auto flex min-h-[620px] items-center px-4 py-14 lg:min-h-[680px] lg:py-20">
          <div className="w-full max-w-2xl text-left">
            <div className="mb-6 flex items-center gap-4 text-xs font-black uppercase tracking-[0.18em] text-slate-200 sm:text-sm">
              <span className="h-0.5 w-12 bg-yellow-400" />
              Quality you can trust. Prices you’ll love.
            </div>

            <h1 className="max-w-xl font-serif text-5xl font-semibold leading-[0.96] tracking-tight text-white sm:text-6xl lg:text-7xl">
              Certified Used Appliances
              <span className="mt-2 block text-yellow-400">Like New.</span>
            </h1>

            <p className="mt-7 max-w-xl text-lg leading-8 text-slate-200 sm:text-xl">
              Big-brand appliances at discounted prices. Shop local and save more with confidence.
            </p>

            <Link
              to="/shop"
              className="mt-9 inline-flex items-center gap-3 rounded-xl bg-yellow-400 px-7 py-4 text-base font-black text-slate-950 shadow-[0_14px_35px_rgba(250,204,21,0.25)] transition hover:-translate-y-0.5 hover:bg-yellow-300 hover:shadow-[0_18px_42px_rgba(250,204,21,0.32)] focus:outline-none focus:ring-2 focus:ring-yellow-300 focus:ring-offset-2 focus:ring-offset-slate-950 sm:px-8 sm:text-lg"
            >
              <ShoppingCart className="h-5 w-5" aria-hidden="true" />
              Shop Now
            </Link>

            <div className="mt-11 grid gap-5 border-t border-white/15 pt-6 sm:grid-cols-3">
              {trustItems.map(({ title, description, icon: Icon }) => (
                <div key={title} className="flex items-start gap-3">
                  <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full border border-white/20 bg-white/10 text-yellow-300 backdrop-blur-sm">
                    <Icon className="h-5 w-5" aria-hidden="true" />
                  </div>
                  <div>
                    <p className="text-sm font-extrabold text-white">{title}</p>
                    <p className="mt-1 text-xs leading-5 text-slate-300">{description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
